import { Link } from "react-router-dom";

function statusBadge(s) {
  const map = {
    pending: "bg-amber-50 text-amber-700 border-amber-200",
    in_audit: "bg-sky-50 text-sky-700 border-sky-200",
    completed: "bg-emerald-50 text-emerald-700 border-emerald-200",
  };
  const label = { pending: "Pending", in_audit: "In Audit", completed: "Completed" }[s] ?? s;
  return <span className={`inline-block px-2 py-0.5 rounded-full text-xs font-medium border ${map[s]}`}>{label}</span>;
}

export default function ChartTable({ charts, linkTo = (c) => `/charts/${c.id}`, showQA = true, showCoder = false, emptyMsg = "No charts yet." }) {
  if (!charts?.length) return <div className="text-sm text-slate-500 py-8 text-center">{emptyMsg}</div>;
  return (
    <div className="overflow-x-auto border border-slate-200 rounded-xl bg-white">
      <table className="w-full text-sm" data-testid="charts-table">
        <thead className="bg-slate-50 text-slate-600 text-xs uppercase tracking-wider">
          <tr>
            <th className="text-left px-4 py-3">Chart</th>
            <th className="text-left px-4 py-3">Patient</th>
            <th className="text-left px-4 py-3">Assessment</th>
            <th className="text-left px-4 py-3">M1021</th>
            <th className="text-left px-4 py-3">M1023</th>
            {showCoder && <th className="text-left px-4 py-3">Coder</th>}
            {showQA && <th className="text-left px-4 py-3">QA</th>}
            <th className="text-left px-4 py-3">Status</th>
            <th className="text-left px-4 py-3">Score</th>
            <th className="px-4 py-3"></th>
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-100">
          {charts.map((c) => (
            <tr key={c.id} className="hover:bg-slate-50" data-testid={`row-${c.chart_id}`}>
              <td className="px-4 py-3 font-medium text-slate-900">{c.chart_id}</td>
              <td className="px-4 py-3 text-slate-700">{c.patient_name}</td>
              <td className="px-4 py-3 text-slate-700">
                <div className="text-sm">{c.assessment_date}</div>
                <div className="text-xs text-slate-500">{c.assessment_type}</div>
              </td>
              <td className="px-4 py-3 text-slate-700 font-mono">
                {c.m1021_primary ? <span className="bg-sky-50 text-sky-700 text-xs rounded px-1.5 py-0.5">{c.m1021_primary}</span> : "—"}
              </td>
              <td className="px-4 py-3 text-slate-700">
                <div className="flex flex-wrap gap-1">
                  {(c.m1023_codes || []).slice(0, 4).map((row) => (
                    <span key={row.slot} className="text-xs bg-slate-100 font-mono px-1.5 py-0.5 rounded">
                      <span className="text-slate-500 mr-0.5">{row.slot}:</span>{row.code}
                    </span>
                  ))}
                  {(c.m1023_codes || []).length > 4 && <span className="text-xs text-slate-500">+{c.m1023_codes.length - 4}</span>}
                </div>
              </td>
              {showCoder && <td className="px-4 py-3 text-slate-700">{c.submitted_by_name || "—"}</td>}
              {showQA && <td className="px-4 py-3 text-slate-700">{c.assigned_qa_name || "—"}</td>}
              <td className="px-4 py-3">{statusBadge(c.status)}</td>
              <td className="px-4 py-3 text-slate-700">{c.audit?.score != null ? `${c.audit.score}%` : "—"}</td>
              <td className="px-4 py-3 text-right">
                <Link to={linkTo(c)} data-testid={`view-${c.chart_id}`} className="text-sky-700 hover:text-sky-900 text-sm font-medium">Open →</Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
